'use client';
import { useQuery } from '@tanstack/react-query';
import { useState } from 'react';
import { v4 as uuidv4 } from 'uuid';

import { ApiResponse } from '@cineamo/api/types/ApiResponse.types';

import { type EmbeddedOf, type ItemOfEmbedded, getAllListItems } from '../helpers/get-all-list-items';

type EmbeddedKeys<QueryResult> = Extract<keyof NonNullable<EmbeddedOf<QueryResult>>, string>;
type EmbeddedItem<QueryResult, QueryResultEmbeddedKeys extends EmbeddedKeys<QueryResult>> = ItemOfEmbedded<
    NonNullable<EmbeddedOf<QueryResult>>,
    QueryResultEmbeddedKeys
>;

type UseGetAllListItemsReturn<TItemDto> = {
    data: TItemDto[];
    isLoading: boolean;
    reload: () => void;
    refetch: () => void;
};

/** @deprecated TODO: This should be moved to another package. Maybe api?  */
export function useGetAllListItems<
    QueryFn extends (page: number, ...args: unknown[]) => Promise<ApiResponse>,
    QueryResult = Awaited<ReturnType<QueryFn>>,
    QueryResultEmbeddedKeys extends EmbeddedKeys<QueryResult> = EmbeddedKeys<QueryResult>
>(
    queryFn: QueryFn,
    listAccessor: QueryResultEmbeddedKeys,
    dependencies?: (string | unknown)[],
    options?
): UseGetAllListItemsReturn<EmbeddedItem<QueryResult, QueryResultEmbeddedKeys>> {
    const [uuid] = useState(uuidv4());
    const queryKey = dependencies?.length > 0 ? dependencies : [uuid];
    const {
        data = [],
        refetch,
        isLoading
    } = useQuery<EmbeddedItem<QueryResult, QueryResultEmbeddedKeys>[]>({
        queryKey: queryKey,
        queryFn: async () => {
            return await getAllListItems({
                queryFn: queryFn,
                listAccessor: listAccessor,
                page: 1
            });
        },
        ...options
    });

    function reload() {
        // remove();
        refetch();
    }

    return {
        data: data || [],
        isLoading: isLoading,
        reload: reload,
        refetch: refetch
    };
}
